<template>
    <footer class="footer-main">
        <div class="container">

            <div class="row">
                <div class="col-lg-5 mr-auto mb-3">
                    <div class="small">
                        We are a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for us to earn fees by linking to Amazon.com and affiliated sites.
                    </div>
                </div>
            </div>

            <div class="row footer-main__bottom-text">
                <div class="col-lg-6 footer-main__bottom-text__left">
                    <div>Copyright &copy; 2017 - {{ new Date().getFullYear() }} <a href="https://innermonkdesign.com" target="_blank">Inner Monk Design</a></div>
                </div>

                <div class="col-lg-6 footer-main__bottom-text__right">
                    <router-link :to="{name: 'tos'}">
                        Terms and Conditions
                    </router-link>

                    /

                    <router-link :to="{name: 'privacy'}">
                        Privacy Policy
                    </router-link>
                </div>
            </div>

        </div>
    </footer>
</template>

<script>

export default {
    name: 'footer-main',
    data () {
        return {
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .footer-main {
        background: $dark-purple;
        padding: 30px 0;
        border-top: 3px solid rgba($purple, 0.25);
        color: darken($white, 20%);
        font-size: 0.85rem;

        &__bottom-text {

            a {
                color: darken($white, 20%);
            }

            &__left {
                text-align: center;
                margin-bottom: 10px;
            }

            &__right {
                text-align: center;
            }

            @media (min-width: 992px) {
                &__left {
                    text-align: left;
                    margin-bottom: 0;
                }

                &__right {
                    text-align: right;
                }
            }
        }
    }


</style>
